module.exports = __webpack_public_path__ + "img/duy.f544a5d4.jpeg";